export default __webpack_public_path__ + "static/media/mc_lid_close.a347bf58.svg";